import Utils from './Utils'

class FilterList {

  /*
  * Return object = {filterlist: 'filter_list_value'}
  */
  getFilter() {
    return Utils.getApaMetadataKey('byr_filterlist_configuration', '{}', 'filterlist')
  }
}

export default new FilterList();



// WEBPACK FOOTER //
// ./src/utils/FilterList.js